<script lang="ts">
    import type { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
    import type {
        DynamicModuleDefinition,
        ExtractModuleType,
    } from "@modules/dynamic_import/types";

    type T = $$Generic;

    //Props
    export let definition: DynamicModuleDefinition<{ default: T }>;
    export let dynamicImportManager: DynamicImportManager;
    export let shouldImportModule: boolean;

    let module: ExtractModuleType<typeof definition>["default"];

    const importModule = async () => {
        if (module) return;

        try {
            module = await dynamicImportManager.importDefault(definition, true);
        } catch (error) {
            console.error(error);
        }
    };

    $: if (shouldImportModule) importModule();
</script>

<slot value={{ module, importModule }} />
